import React from 'react';

/**
 * Vertical milestone rail — shared by Visit / Medicine / Investigation history.
 */
export function ClinicalMilestoneTimeline({
  children,
  accent = '#071B34',
  testId = 'clinical-milestone-timeline',
}) {
  return (
    <ol
      className="relative ml-3 space-y-0 border-l-2 border-[#D5DEE8]"
      data-testid={testId}
    >
      {React.Children.map(children, (child) => {
        if (!React.isValidElement(child)) return child;
        return React.cloneElement(child, { accent: child.props.accent || accent });
      })}
    </ol>
  );
}

export function MilestoneItem({ accent = '#071B34', children, testId }) {
  return (
    <li className="relative pb-5 pl-5 last:pb-0" data-testid={testId}>
      <span
        className="absolute -left-[7px] top-1.5 h-3 w-3 rounded-full border-2 border-white shadow"
        style={{ background: accent }}
      />
      <div className="rounded-xl border border-[#D5DEE8] bg-white px-3.5 py-3 shadow-sm">
        {children}
      </div>
    </li>
  );
}

export function MilestoneEmpty({ icon: Icon, text, subtext }) {
  return (
    <div className="py-16 text-center text-[#9AADBE]">
      {Icon ? <Icon className="mx-auto h-8 w-8 opacity-40" /> : null}
      <p className="mt-2 text-sm font-medium text-[#5A6B7C]">{text}</p>
      {subtext ? <p className="mt-1 text-xs">{subtext}</p> : null}
    </div>
  );
}
